import DaumPostcode, { Address } from 'react-daum-postcode';

import ModalBox from '../../Modal/ModalBox/ModalBox';
import ModalPortal from '../../Modal/ModalPortal/ModalPortal';

import * as S from './style';

interface InputAddressProps {
	setIsOpen: (isOpen: boolean) => void;
	setAddress: (address: Address) => void;
}
const InputAddress = ({ setIsOpen, setAddress }: InputAddressProps) => {
	const themeObj = {
		postcodeTextColor: '#FA7142',
		emphTextColor: '#333333',
	};
	const completeHandler = (data: Address) => {
		setAddress(data);
	};
	const closeHandler = (state: string) => {
		if (state === 'FORCE_CLOSE' || state === 'COMPLETE_CLOSE') {
			setIsOpen(false);
		}
	};
	const style = {
		width: '100%',
		height: 'min(50rem, calc(100vh - 14rem))',
		border: '1px solid #dee2e6',
		boxSizing: 'border-box' as const,
	};

	return (
		<ModalPortal>
			<ModalBox title="주소찾기" onClick={setIsOpen} isCloseButton maxWidth="44rem">
				<S.PostcodeWrap>
					<DaumPostcode theme={themeObj} style={style} onComplete={completeHandler} onClose={closeHandler} />
				</S.PostcodeWrap>
			</ModalBox>
		</ModalPortal>
	);
};

export default InputAddress;
